import { PocStep } from 'commons/components/components-wrapper/poc-step.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { AutomationRulesStepperStyled } from '../styled/automation-rules.style';

export interface StepperOption {
    title: string;
    content: React.ReactNode;
}

interface AutomationRulesStepperProps {
    options?: StepperOption[];
}

export const AutomationRulesStepper = (props: AutomationRulesStepperProps) => {
    const { options = [] } = props;
    return (
        <AutomationRulesStepperStyled direction="vertical" linear>
            {options?.map((el, index) => {
                const { title, content } = el;
                return (
                    <PocStep status="default" key={`automation-rule-stepper-${el.title}-${index}`}>
                        <div slot="title" style={{ color: 'unset', paddingBottom: '16px', paddingLeft: '2px' }}>
                            <PocTypography variant="tab">{title}</PocTypography>
                        </div>
                        {content}
                    </PocStep>
                );
            })}
        </AutomationRulesStepperStyled>
    );
};

AutomationRulesStepper.displayName = 'AutomationRulesStepper';
